/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Decision_Desk_DescInputs */

const en_directory_detail_decision_desk_desc = /** @type {(inputs: Directory_Detail_Decision_Desk_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The questions most worth resolving before you rely on the product or visit its official site.`)
};

const zh_directory_detail_decision_desk_desc = /** @type {(inputs: Directory_Detail_Decision_Desk_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在依赖该产品或访问官网前，最值得先确认的问题。`)
};

/**
* | output |
* | --- |
* | "The questions most worth resolving before you rely on the product or visit its official site." |
*
* @param {Directory_Detail_Decision_Desk_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_decision_desk_desc = /** @type {((inputs?: Directory_Detail_Decision_Desk_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Decision_Desk_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_decision_desk_desc(inputs)
	return zh_directory_detail_decision_desk_desc(inputs)
});
export { directory_detail_decision_desk_desc as "directory.detail.decision_desk_desc" }